import {GroupedAttributeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutGroupedAttributes} from '@aboutyou/ui-components';
import React from 'react';
import {useGroupedAttributesSection} from '../../shared/useGroupedAttributesSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: GroupedAttributeFilterSection;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
  setFilter: ({
    filterId,
    filterSection,
    filterSlug,
  }: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
  enableFlyoutFilter: boolean;
};

export const FilterSectionGroupedAttributes: React.FC<Props> = ({
  activeFilters,
  data,
  hide,
  isOpen,
  open,
  submit,
  setFilter,
  enableFlyoutFilter,
}) => {
  const {label} = data;
  const {activeSlugFilters, normalizedGroups, handleItemClick} =
    useGroupedAttributesSection({data, setFilter, activeFilters});

  return (
    <FilterFlyoutGroupedAttributes
      activeIds={activeSlugFilters}
      itemGroups={normalizedGroups}
      hide={hide}
      isOpen={isOpen}
      label={label}
      onItemClick={handleItemClick}
      open={open}
      enableFlyoutFilter={enableFlyoutFilter}
      submit={submit}
    />
  );
};
